var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`spinner--${_vm.variant}`},[_c('svg',{attrs:{"height":_vm.size,"width":_vm.size,"viewBox":"0 0 50 50"}},[_c('g',{staticClass:"spinner__circular"},[_c('circle',{staticClass:"spinner__path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":_vm.width,"stroke-miterlimit":"10","stroke":"currentColor"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }